export var TracingAccountSubject;
(function (TracingAccountSubject) {
    TracingAccountSubject["CreateTracingAccount"] = "create-tracing-account-success";
    TracingAccountSubject["DeleteTracingAccount"] = "delete-tracing-account-success";
    TracingAccountSubject["UpdateTracingAccount"] = "update-tracing-account-success";
})(TracingAccountSubject || (TracingAccountSubject = {}));
//# sourceMappingURL=manage-tracing-accounts.enum.js.map